import { useLanguageControls } from '../../../../hooks/useLanguageControls';

export default function getAchievementProgress({ progress, quest_trigger_count: target }) {
  const { isArabic } = useLanguageControls();

  const current = Math.min(progress ?? 0, target);
  return {
    proportion: isArabic ? `${target}/${current ?? 0}` : `${current ?? 0}/${target}`,
    normalizedProgress: isArabic ? target / current : current / target,
    percentage: +((current / target) * 100).toFixed(0),
  };
}
